<template>
	<div>
		<div class="row">
			<div class="col-12">
				<div class="ibox">
					<div class="ibox-content">
						<div class="row d-flex justify-content-center">
							<div class="col-md-4 text-center" v-if="activeCheckingPlace == null">
								<form @submit.prevent="prepareChecking">
									<div class="input-group">
										<span class="form-control">ellenőrzési mód</span>
										<div class="input-group-append" v-for="method_item in methods"
											:key="method_item.value"
											v-show="!((count_type == 3 || count_type == 4) && method_item.value == 'standard')">
											<button type="button" class="btn"
												:class="{ 'btn-primary': method == method_item.value, 'btn-white': method != method_item.value }"
												@click="changeMethod(method_item.value)">{{ method_item.name }}</button>
										</div>
									</div>
									<hr>
									<h3 class="text-center">Raktárhely: </h3>
									<div class="input-group">
										<input ref="place_barcode_input" class="form-control form-control-lg text-center"
											@focus="$event.target.select()" type="text" v-model="place_barcode" />
										<!-- <div class="input-group-append">
												<select v-model="method" class="input-group-addon">
													<option @click="$refs.place_barcode_input.focus()" @touch="$refs.place_barcode_input.focus()" v-show="!(count_type == 3 && method_item.value == 'standard')" v-for="method_item in methods" :key="method_item.value" :value="method_item.value">{{method_item.name}}</option>
												</select>
											</div> -->
									</div>
									<div v-if="place_not_found == true" class="label label-danger">
										NEM TALÁLHATÓ!
									</div>
								</form>
							</div>
							<div class="col-md-6 text-center" v-if="checking === true">
								<div v-if="method == 'status'">
									<div class="input-group">
										<span class="text-center form-control">{{ methods[methods.map(item =>
											item.value).indexOf(method)].name }} ellenőrzés</span>
										<span class="text-center bg-success form-control text-white"
											v-if="activeCheckingPlace != null"> Raktárhely -
											{{ activeCheckingPlace.barcode }}</span>
									</div>
									<div class="ibox">
										<div class="ibox-content">
											<button class="btn btn-info" @click="openSumModal()">Σ SUM</button>
											<h4 style="white-space: pre-line; line-height: 200%;">
												{{ status }}
											</h4>
											<button class="btn btn-danger" @click="closePlace()">Bezárás <i
													class="fa fa-times"></i></button>
										</div>
									</div>
								</div>
								<div v-else>
									<div class="input-group">
										<button @click="openUnknownModal()" class="btn btn-warning"><i
												class="fa fa-question-circle"></i> Új tétel</button>
										<span class="text-center form-control">{{ methods[methods.map(item =>
											item.value).indexOf(method)].name }} ellenőrzés</span>
										<button class="btn btn-info" @click="openSumModal()">Σ SUM</button>
									</div>
									<hr>
									<span class="text-center bg-success p-1 fs-lg b-r-md"
										v-if="activeCheckingPlace != null"> Raktárhely -
										{{ activeCheckingPlace.barcode }}</span>
									<div v-if="method == 'quick'">
										<h5>Rendezés szempontja:</h5>
										<button class="btn btn-sm"
											:class="{ 'btn-info': currentSort == 'line_number', 'btn-link': currentSort != 'line_number' }"
											@click="sort('line_number')">
											Felvétel sorrendje
											<i v-if="currentSort == 'line_number' && currentSortDir == 'asc'"
												class="fa fa-caret-down"></i>
											<i v-if="currentSort == 'line_number' && currentSortDir == 'desc'"
												class="fa fa-caret-up"></i>
										</button>
										<button class="btn btn-sm"
											:class="{ 'btn-info': currentSort == 'barcode', 'btn-link': currentSort != 'barcode' }"
											@click="sort('barcode')">
											Vonalkód
											<i v-if="currentSort == 'barcode' && currentSortDir == 'asc'"
												class="fa fa-caret-down"></i>
											<i v-if="currentSort == 'barcode' && currentSortDir == 'desc'"
												class="fa fa-caret-up"></i>
										</button>
									</div>
									<table class="table mt-2 w-100">
										<tbody>
											<tr v-for="(item, id) in sortedActiveCheckItems" :key="id"
												v-bind:class="{ 'bg-muted': item.status == 0, 'bg-salmon text-white': item.status == 1, 'bg-limegreen text-white': item.status == 2, 'bg-primary-dark text-white': item.status == 3, 'active-check-item-border': item.active === true }"
												:ref="item.id + '_row'">
												<td>{{ item.line_number }}</td>
												<td class="text-break" @click="setActive(item)">{{ item.name }} <br>
													{{ item.barcode }}</td>
												<td>{{ item.original_amount }}</td>
												<td class="table-input-wide">
													<form @submit.prevent="submitItemCheck(item)"
														v-if="item.active === true">
														<div class="input-group">
															<input :ref="item.id + '_check_input'" type="number" min="0"
																step="0.001" @focus="$event.target.select()"
																@blur="validateAmount(item, 1)"
																class="text-right form-control text-dark table-input-wide"
																v-model="item.check"><br>
															<button type="submit"
																class="btn btn-success	table-input-wide">OK</button>
														</div>
													</form>
													<form @submit.prevent="validateAmount(item, 1)" v-else>
														<input :ref="item.id + '_check_input_no_form'" min="0" step="0.001"
															type="number" @focus="$event.target.select()"
															@blur="validateAmount(item)"
															class="text-right form-control text-dark d-inline-block"
															v-model="item.check">
													</form>
												</td>
											</tr>
										</tbody>
									</table>
									<button ref="finishButton" class="btn btn-primary mt-2 btn-lg"
										@click="finishPlace()">Lezárás <i class="fa fa-lock"></i></button>
								</div>
							</div>
						</div>
						<div class="row">
						</div>
					</div>
				</div>
			</div>
		</div>
		<div id="modal">
			<modal-vue modalSize="sm" @on-close="closeUnknownModal()" name="unknown_modal"
				:headerOptions="{ title: 'Új tétel' }" :footerOptions="{
					btn1: 'Mégse',
					disableBtn2: true,
					btn1OnClick: () => {
						closeUnknownModal();
					},
				}">
				<!-- <div class="row d-flex justify-content-center" v-if="supervisor_access == false">
					<div class="col-10 text-center">
						<h3>Adja meg a supervisori jelszót</h3>
						<form @submit.prevent="checkSupervisorPass($event)">
							<input v-model="form_pass" type="password" class="form-control text-center" inputmode="numeric">
							<div class="label label-danger" v-if="errors.form_pass">{{errors.form_pass[0]}}</div>
							<button type="submit" class="btn btn-primary mt-2"><i class="fa fa-key"></i> Feloldás</button>
						</form>
					</div>
				</div> -->
				<div class="row d-flex justify-content-center"> <!--v-else-->
					<div class="col-10 text-center overflow-auto">
						<form v-if="!errors.extra_item" @submit.prevent="supervisorSubmit()">
							<div class="form-group">
								<label>Vonalkód:</label>
								<input type="number" v-model="extra_item.barcode" class="form-control" required>
								<div class="label label-danger" v-if="errors.extra_barcode">{{ errors.extra_barcode[0] }}
								</div>
							</div>
							<div class="form-group">
								<label>Mennyiség:</label>
								<input type="number" min="0" step="0.001" max="9999" v-model="extra_item.original_amount"
									class="form-control" required>
								<div class="label label-danger" v-if="errors.original_amount">{{ errors.original_amount[0] }}
								</div>
							</div>
							<button type="submit" class="btn btn-primary">Rögzítés</button>
						</form>
						<div v-else>
							<div class="bg-danger">{{ errors.extra_item[0] }}</div>
							<h3>Adja meg a supervisori jelszót</h3>
							<form @submit.prevent="simpleSupervisorCheck()">
								<input v-model="form_pass" type="password" class="form-control text-center"
									inputmode="numeric">
								<div class="label label-danger" v-if="errors.form_pass"><i
										class="fa fa-exclamation-triangle"></i> {{ errors.form_pass[0] }}</div>
								<button type="submit" class="btn btn-warning mt-2">Ismeretlen rögzítése</button>
							</form>
						</div>
					</div>
				</div>
			</modal-vue>
		</div>
		<div id="sum_modal">
			<modal-vue modalSize="sm" @on-close="closeSumModal()" name="sum_modal" :headerOptions="{ title: 'Σ SUM' }"
				:footerOptions="{
					btn1: 'Mégse',
					btn2: 'Σ SUM',
					btn2OnClick: () => {
						this.$refs['sum_submit'].click();
					},
					btn1OnClick: () => {
						closeSumModal();
					},
				}">
				<div class="row d-flex justify-content-center"> <!--v-else-->
					<div class="col-10 text-center overflow-auto">
						<h3>Vonalkód:</h3>
						<form @submit.prevent="checkSum()">
							<input required ref="sum_barcode" type="text" class="form-control text-center"
								@focus="$event.target.select()" v-model="sum_barcode">
							<button type="submit" hidden ref="sum_submit"></button>
						</form>
						<h3 v-if="sum_result != 0 && sum_result != null">{{ sum_result.name }}</h3>
						<h2 v-if="sum_result != 0 && sum_result != null">{{ sum_result.amount }}db</h2>
						<div class="label label-danger mt-0" v-if="sum_result == 0">Nem található!</div>
					</div>
				</div>
			</modal-vue>
		</div>
	</div>
</template>

<script>
import appService from '../../apis/appService.js';
import Barcode from '../../apis/Barcode.js';
import moment from 'moment'
export default {
	data() {
		return {
			errors: [],
			place_barcode: null,
			sum_result: null,
			sum_barcode: null,
			place_not_found: false,
			place_found: false,
			method: "standard",
			checking: false,
			activeCheckItems: false,
			status: null,
			supervisor_access: false,
			form_pass: null,
			extra_item: {},
			currentSort: 'line_number',
			currentSortDir: 'asc',
			correct_barcode_sound: require('../../assets/sounds/ES_Multimedia_781.mp3'),
			wrong_barcode_sound: require('../../assets/sounds/ES_MM_Error_23.mp3'),
			correct_amount: require('../../assets/sounds/select-click-1109.wav'),
			wrong_amount: require('../../assets/sounds/click-error-1110.wav'),
		}
	},
	computed: {
		activeCheckingPlace() {
			return this.$store.state.activeCheckingPlace;
		},
		methods() {
			return this.$store.state.methods;
		},
		lszsz() {
			return this.$store.state.lszsz;
		},
		count_type() {
			return this.$store.state.count_type;
		},
		supervisor_code() {
			return this.$store.state.supervisor_code;
		},
		user() {
			return this.$store.state.user;
		},
		sortedActiveCheckItems: function () {
			return this.activeCheckItems.filter(() => {
				return true;
			}).sort((a, b) => {
				let modifier = 1;
				if (this.currentSortDir === 'desc') modifier = -1;
				if (a[this.currentSort] < b[this.currentSort]) return -1 * modifier;
				if (a[this.currentSort] > b[this.currentSort]) return 1 * modifier;
				return 0;
			});
		}
	},
	mounted() {
		this.$refs.place_barcode_input.focus();
	},
	created() {
		this.$store.commit('updateSubTitle', 'Ellenőrzés');
		console.log(this.count_type);
		if (this.count_type == 3) {
			this.method = "quick";
		}
	},

	methods: {
		checkPlaceBarcodeAndTransform() {
			if (this.place_barcode.length == 20) {
				let clean = this.place_barcode.substr(11, 8)
				this.place_barcode = clean.substr(0, 1) + '-' + clean.substr(1, 3) + '-' + clean.substr(4, 2) + '-' + clean.substr(6, 2);
			}
		},
		simpleSupervisorCheck() {
			if (this.form_pass == this.supervisor_code) {
				this.errors = [];
				this.supervisorStore();
			} else {
				this.$set(this.errors, 'form_pass', ['helytelen jelszó']);
			}
		},
		setActive(item) {
			let vue = this;
			new Promise(resolve => {
				let activenow = vue.sortedActiveCheckItems.filter(checkitem => checkitem.active == true)[0];
				if (activenow != null) {
					activenow.active = false;
				}
				resolve('finished');
			}).then(() => {
				this.$set(item, 'active', true);
			}).then(() => {
				this.$refs[item.id + '_row'][0].scrollIntoView({ behavior: "smooth", block: "end", inline: "nearest" });
				this.$refs[item.id + '_check_input'][0].focus();
			});
		},
		changeMethod(method) {
			this.$set(this, 'method', method);
			this.$refs.place_barcode_input.focus();
		},
		startChecking() {
			let vue = this;
			new Promise(resolve => {
				vue.activeCheckItems.forEach(item => {
					item.active = false;
				});
				resolve('finished');
			}).then(() => {
				let item = this.sortedActiveCheckItems.filter(checkitem => checkitem.status == 1)[0];
				this.$set(item, 'active', true);
			})
				.then(() => {
					let item = this.sortedActiveCheckItems.filter(checkitem => checkitem.status == 1)[0];
					this.$refs[item.id + '_row'][0].scrollIntoView({ behavior: "smooth", block: "end", inline: "nearest" });
					this.$refs[item.id + '_check_input'][0].focus();
				});
		},
		sort(s) {
			new Promise(resolve => {
				//if s == current sort, reverse
				if (s === this.currentSort) {
					this.currentSortDir = this.currentSortDir === 'asc' ? 'desc' : 'asc';
				}
				this.currentSort = s;
				if (this.activeCheckItems.filter(item => [0, 1].includes(item.status)).length != 0) {
					resolve('finished');
				}
			})/*.then(()=>{
					this.startChecking();
				})*/;
		},
		supervisorSubmit() {

			if (this.count_type == 2) {
				//obi
				this.extra_item.barcode = Barcode.obiBarcodeSlice(this.extra_item.barcode);
			} else {
				this.extra_item.barcode = Barcode.regularBarcodeSlice(this.extra_item.barcode);
			}

			let itemName = appService.checkBarcode(this.extra_item.barcode);
			if (itemName) {
				this.extra_item.name = itemName;
				this.supervisorStore();
			} else {
				this.$set(this.errors, 'extra_item', ['Ismeretlent csak Supervisor jelszóval adhat meg! ' + this.extra_item.barcode])
			}
		},
		supervisorStore() {
			if (this.extra_item.original_amount > 100) {
				this.$confirm({
					message: 'A megadott mennyiség: ' + this.extra_item.original_amount + ' nagyobb mint 100, biztos rögzíti?',
					button: {
						no: 'mégse',
						yes: 'OK'
					},
					callback: confirm => {
						if (confirm) {
							this.supervisorStoreProcess();
						} else {
							this.$set(this, 'errors', []);
						}
					}
				});
			} else {
				this.supervisorStoreProcess();
			}
		},
		supervisorStoreProcess() {
			appService.playAndroidSound('correct_amount');
			let vue = this;
			new Promise(resolve => {
				vue.extra_item.timestamp = moment().format('YYYY-MM-DD HH:mm:ss');
				vue.extra_item.check = vue.extra_item.original_amount;
				vue.extra_item.iid = 0;
				vue.extra_item.status = 0;
				vue.extra_item.line_number = Math.max.apply(Math, vue.activeCheckItems.map(item => item.line_number)) + 1;
				vue.extra_item.id = vue.activeCheckItems.length + 1;
				vue.extra_item.active = false;
				vue.activeCheckItems.push(vue.extra_item);
				console.log(vue.activeCheckItems);
				vue.$set(this, 'errors', []);
				vue.extra_item = {};
				vue.closeUnknownModal();
				resolve('finished');
			}).then(() => {
				this.startChecking();
			});
		},
		checkSupervisorPass() {
			console.log(' checking passw ' + typeof this.form_pass + ' =? ' + typeof this.supervisor_code);
			if (this.form_pass == this.supervisor_code) {
				console.log("access granted");
				this.supervisor_access = true;
				this.errors = [];
			} else {
				console.log("access denied");
				this.$set(this.errors, 'form_pass', ['helytelen jelszó']);
				console.log(this.errors);
			}
		},
		closeUnknownModal() {
			this.$vm2.close('unknown_modal');
			this.supervisor_access = false;
			this.form_pass = null;
			this.$set(this, 'errors', []);
			this.extra_item = {};
		},
		closeSumModal() {
			this.sum_result = null;
			this.$vm2.close('sum_modal');
		},
		openUnknownModal() {
			this.$set(this.extra_item, 'name', 'ISMERETLEN');
			this.$vm2.open('unknown_modal');
		},
		openSumModal() {
			let vue = this;
			new Promise(resolve => {
				vue.$vm2.open('sum_modal');
				resolve('finished');
			}).then(() => {
				this.$refs['sum_barcode'].focus();
			});
		},
		checkSum() {
			this.$refs['sum_barcode'].blur();
			this.sum_barcode = Barcode.regularBarcodeSlice(this.sum_barcode);
			if (this.method == 'status') {
				appService.checkCheckingPlace(this.place_barcode, this.user.project_id, this.lszsz, appService.getDeviceId())
					.then(response => {
						this.calcSum(response.data);
					});
			} else {
				this.calcSum(this.sortedActiveCheckItems);
			}
		},
		calcSum(sumarray) {
			let records = null;
			records = sumarray.filter(record => record.barcode == this.sum_barcode);
			if (records.length != 0) {
				let amount = records.reduce(function (a, b) {
					return parseFloat(a) + parseFloat(b['original_amount']);
				}, 0);
				this.sum_result = {
					amount: amount,
					name: records[0].name
				}
			} else {
				this.sum_result = 0
			}
			this.$refs['sum_barcode'].focus();
		},
		prepareChecking() {
			this.place_barcode = Barcode.placeBarcodeSlice(this.place_barcode);
			this.$refs.place_barcode_input.blur();

			//FIXME itt kéne megoldani, hogy legyen egy kérés, ami lekérdezi, hogy milyen szátuszban van a leltárhely
			appService.getStatusPlace(this.place_barcode, this.user.project_id, this.lszsz, appService.getDeviceId()).then(response => {
				if (response.data.status >= 10){//már ellenőrzött státuszban van
					this.$confirm({
						message: 'Már ellenőrzött státuszban van a raktárhely, biztos újra ellenőrzöd?',
						button: {
							no: 'Nem',
							yes: 'Igen, újra ellenőrzés'
						},
						callback: confirm => {
							if (confirm) {
								this.prepareMethodChecking();
							} else {
								this.$refs.place_barcode_input.val('');
								return;
							}
						}
					});
				}else{
					this.prepareMethodChecking();
				}
			});
		},
		prepareMethodChecking() {
			switch (this.method) {
				case 'standard':
					this.checkCheckingPlace();
					break;
				case 'quick':
					if (this.count_type == 3 || this.count_type == 4) {
						appService.checkStatusPlace(this.place_barcode, this.user.project_id, this.lszsz, appService.getDeviceId()).then(response => {
							this.$confirm({
								message: response.data,
								button: {
									no: 'Tételes ellenőrzés',
									yes: 'OK'
								},
								callback: confirm => {
									if (confirm) {
										this.setQuickPlace()
									} else {
										this.checkCheckingPlace();
									}
								}
							});
						})
					} else {
						this.checkCheckingPlace();
					}
					break;
				case 'status':
					this.checkStatusPlace();
					break;
			}
		},
		setQuickPlace() {
			appService.setQuickPlace(this.place_barcode, this.user.project_id, this.lszsz, appService.getDeviceId()).then(() => {
				this.$toast.open({
					message: 'sikeres ellenőrzés',
					position: 'top'
				});
				this.$refs.place_barcode_input.focus();
			}).catch(error => {
				this.$toast.open({
					message: error.response.data.error.message,
					type: 'error',
					position: 'top'
				});
			})
		},
		checkStatusPlace() {
			appService.checkStatusPlace(this.place_barcode, this.user.project_id, this.lszsz, appService.getDeviceId()).then(response => {
				this.status = response.data;
			}).then(() => {
				appService.playAndroidSound('correct_barcode');
				this.checking = true;
				this.place_found = true;
				this.place_not_found = false;
				this.$store.commit('updateActiveCheckingPlace', { barcode: this.place_barcode });
			}).catch(() => {
				appService.playAndroidSound('wrong_barcode');
				this.place_not_found = true;
			});
		},
		checkCheckingPlace() {
			appService.checkCheckingPlace(this.place_barcode, this.user.project_id, this.lszsz, appService.getDeviceId())
				.then((response) => {
					this.activeCheckItems = response.data;
					if (this.method == 'quick') {
						let status = 0;
						if (this.count_type == 3 || this.count_type == 4) {
							status = 1;
						}
						this.activeCheckItems.forEach(item => {
							this.$set(item, 'status', status);
						})
					}
				}).then(() => {
					let vue = this;
					new Promise(function (resolve, reject) {
						if (vue.activeCheckItems.length > 0) {
							appService.playAndroidSound('correct_barcode');
							vue.checking = true;
							vue.place_found = true;
							vue.place_not_found = false;
							vue.$store.commit('updateActiveCheckingPlace', { barcode: vue.place_barcode });
							vue.activeCheckItems.forEach((item, id) => {
								item.check = item.original_amount;
								item.id = id;
								vue.$set(item, 'active', false);
							});
							resolve('finished');
						}
						else {
							appService.playAndroidSound('wrong_barcode');
							vue.place_found = false;
							vue.place_not_found = true;
							vue.$store.commit('updateActiveCheckingPlace', null);
							//this.$refs.place_barcode_input.focus();
							reject('Üres raktárhely!');
							vue.$refs.place_barcode_input.focus();
						}
					}).then(() => {
						if (this.method == 'standard' || (this.method == 'quick' && [3, 4].includes(this.count_type))) {
							this.startChecking();
						}
					})
						.catch(error => {
							appService.playAndroidSound('wrong_barcode');
							console.log(error);
							this.$toast.open({
								type: 'error',
								message: error,
								position: 'top'
							});
						})
				}).catch(error => {
					appService.playAndroidSound('wrong_barcode');
					this.$refs.place_barcode_input.focus();
					this.$toast.open({
						type: 'error',
						message: error.response.data.error.message,
						position: 'top',
					});
				});
		},
		countDecimals(amount) {
			if (Math.floor(amount) === parseFloat(amount)) {
				return 0;
			} else {
				return amount.toString().split(".")[1].length;
			}
		},
		validateAmount(item, confirm_off = null) {
			console.log('item_to_validate');
			console.log(item);
			console.log('.....................');
			let error = null
			if (!item.check) {
				error = 'adj meg egy számot!'
			} else if (this.countDecimals(item.check) > 3) {
				error = '3 tizedesig adhatja meg a mennyiséget'
			} else if (item.check > 9999) {
				error = 'max 9999 lehet!'
			} else if (item.check < 0) {
				error = 'nem lehet negatív!'
			} else if (String(item.check).charAt(0) == ',' || String(item.check).charAt(0) == '.') {
				error = 'csak számmal kezdődhet!'
			}
			if (error != null) {
				appService.playAndroidSound('wrong_amount');
				this.$refs[item.id + '_check_input_no_form'][0].focus();
				this.$toast.open({
					message: error,
					type: 'error',
					position: 'top',
				});
				return 0;
			} else if (confirm_off != 1 && item.check > 100) {
				this.$confirm({
					message: 'A rögzíteni kívánt mennyiség: ' + item.check + ' nagyobb mint 100, biztos rögzíti?',
					button: {
						no: 'Nem',
						yes: 'Igen',
					},
					callback: confirm => {
						if (confirm) {
							if (this.$refs[item.id + '_check_input_no_form'][0] != null) {
								this.$refs[item.id + '_check_input_no_form'][0].blur();
							} else {
								this.$refs[item.id + '_check_input'][0].blur();
							}
							if (item.status == 0) {
								this.$set(item, 'status', 2);
							}
							return 1;
						} else {
							if (this.$refs[item.id + '_check_input_no_form'][0] != null) {
								this.$refs[item.id + '_check_input_no_form'][0].focus();
							} else {
								this.$refs[item.id + '_check_input'][0].focus();
							}
							return 0;
						}
					}
				});
			} else {
				if (this.$refs[item.id + '_check_input_no_form'][0] != null) {
					this.$refs[item.id + '_check_input_no_form'][0].blur();
				} else {
					this.$refs[item.id + '_check_input'][0].blur();
				}
				if (item.status == 0) {
					this.$set(item, 'status', 2);
				}
				return 1;
			}
		},
		submitItemCheck(item) {
			let vue = this;
			new Promise((resolve) => {
				let result = vue.validateAmount(item, 1);
				resolve(result);
			}).then(response => {
				console.log('validation result: ' + response);
				if (response == 1 && item.check > 100) {
					this.$confirm({
						message: 'A rögzíteni kívánt mennyiség: ' + item.check + ' nagyobb mint 100, biztos rögzíti?',
						button: {
							no: 'Nem',
							yes: 'Igen',
						},
						callback: confirm => {
							if (confirm) {
								this.submitItem(item);
							} else {
								this.$refs[item.id + '_check_input'][0].focus();
							}
						}
					});
				} else {
					this.submitItem(item)
				}
			});
		},
		submitItem(item) {
			console.log('submititem running');
			let error = null
			console.log(item.check);
			if (!item.check) {
				error = 'adj meg egy számot!'
			} else if (item.check > 9999) {
				error = 'max 9999 lehet!'
				appService.playAndroidSound('wrong_amount');
			}
			if (error != null) {
				this.$refs[item.id + '_check_input'][0].focus();
				this.$toast.open({
					message: error,
					type: 'error',
					position: 'top',
				});
			} else {
				appService.playAndroidSound('correct_amount');
				item.timestamp = moment().format('YYYY-MM-DD HH:mm:ss');
				if (item.status == 1 || item.status == 3) {
					item.status = 3;
				} else {
					item.status = 2;
				}
				//delete item.active;
				item.active = false;
				this.$forceUpdate(item);
				console.log(item.active);
				//let nextindex = this.sortedActiveCheckItems.map(element => element.id).indexOf(item.id)+1;
				let nextitem = this.sortedActiveCheckItems.filter(checkitem => checkitem.status == 1)[0];
				if (/*nextindex != this.sortedActiveCheckItems.length*/ nextitem != null) {
					//let nextitem = this.sortedActiveCheckItems[nextindex]
					let vue = this;
					new Promise(resolve => {
						vue.$set(nextitem, 'active', true);
						resolve('finished');
					}).then(() => {
						this.$refs[nextitem.id + '_row'][0].scrollIntoView({ behavior: "smooth", block: "end", inline: "nearest" });
						this.$refs[nextitem.id + '_check_input'][0].focus();
					});
				} else {
					this.$refs.finishButton.scrollIntoView({ behavior: "smooth", block: "end", inline: "nearest" });
				}
			}


		},
		/*placeResponse(found){
			if(found){
				let vue = this;
				new Promise(function(resolve) {
					vue.place_found = true;
					vue.place_not_found = false;
					vue.items = found;
					vue.$store.commit('updateActiveCheckingPlace',{barcode:vue.place_barcode});
					resolve('finished')
				}).then(() => {
					document.getElementById('navbarNav').collapse();
					//this.$refs.barcode_input.focus();
				});
			}
			else{
				this.place_found = false;
				this.place_not_found = true;
				this.$store.commit('updateActiveCheckingPlace',null);
				//this.$refs.place_barcode_input.focus();
			}
		},*/
		closePlace() {
			let vue = this;
			new Promise(function (resolve) {
				vue.place_found = false;
				vue.checking = false;
				vue.place_not_found = false;
				vue.place_barcode = null;
				vue.$store.commit('updateActiveCheckingPlace', null)
				resolve('finished')
			}).then(() => {
				this.$refs.place_barcode_input.focus();
			});
		},
		finishPlace() {
			if (this.activeCheckItems.filter(item => item.status == 1/*[0,1].includes(item.status)*/).length == 0 || (this.method == 'quick' && [1, 2, 5].includes(this.count_type))) {
				if (this.activeCheckItems.filter(item => (item.check > 9999 || item.check < 0 || item.check == null)).length != 0) {
					this.$toast.open({
						type: 'error',
						message: 'csak 0 és 9999 közti értékeket adhat meg!',
						position: 'top'
					});
				} else {
					if (this.method != 'status') {
						this.$confirm({
							message: `Biztos lezárod ezt a raktárhelyet?`,
							button: {
								no: 'Nem',
								yes: 'Igen'
							},
							/**
							* Callback Function
							* @param {Boolean} confirm
							*/
							callback: confirm => {
								if (confirm) {
									let vue = this;
									new Promise(function (resolve) {
										vue.activeCheckItems.forEach(item => {
											let timestamp = item.timestamp;
											if (item.timestamp == null) {
												timestamp = moment().format('YYYY-MM-DD HH:mm:ss');
											}
											appService.storeCheck(item.line_number, item.barcode, item.check, '', '', timestamp, item.iid)
										})
										resolve('finished')
									}).then(() => {
										appService.finishCheck(this.user.project_id, this.lszsz, this.activeCheckingPlace.barcode, appService.getDeviceId(), moment().format('YYYY-MM-DD HH:mm:ss'));
									}).then(() => {
										this.place_found = false;
										this.checking = false;
										this.place_not_found = false;
										this.place_barcode = null;
										this.$store.commit('updateActiveCheckingPlace', null)
									}).then(() => {
										this.$refs.place_barcode_input.focus();
									});
								}
							}
						});
					} else {
						let vue = this;
						new Promise(function (resolve) {
							vue.place_found = false;
							vue.checking = false;
							vue.place_not_found = false;
							vue.place_barcode = null;
							vue.$store.commit('updateActiveCheckingPlace', null)
							resolve('finished')
						}).then(() => {
							this.$refs.place_barcode_input.focus();
						});
					}
				}
			} else {
				appService.playAndroidSound('wrong_barcode');
				this.$toast.open({
					type: 'error',
					message: 'Még nem ellenőriztél le mindent!',
					position: 'top'
				});
			}
		}
	},
}
</script>

<style></style>